import { css } from 'styled-components';

/**
 * PLEASE NOTE: ::-webkit-scrollbar properties are widely used; however, they are non-standardized.
 *   Browsers that do not support webkit simply ignore the webkit properties.
 *
 *   This custom scrollbar has been customized  *only* for use in the Navigation Menu.
 *   If you need a custom scrollbar for your application, please use customScrollbar instead.
 */

export const customNavScrollbar = () => css`
  overflow-x: hidden;
  overflow-y: auto;

  /* Firefox compatibility */
  @-moz-document url-prefix() {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.color.gray[300].value} transparent;
  }

  /* Chrome and Edge and Safari compatibility */
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.gray[300].value};
    border-left: 3px solid ${({ theme }) => theme.color.gray[50].value};
    border-radius: 8px 4px 4px 8px / 4px 4px 4px 4px;
    &:hover {
      border-left: 1px solid ${({ theme }) => theme.color.gray[50].value};
      border-radius: 4px;
    }
    &:active {
      background: ${({ theme }) => theme.color.gray[400].value};
      border-radius: 4px;
    }
    &:vertical {
      min-height: 32px;
    }
    &:horizontal {
      min-width: 48px;
    }
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
    color: transparent;
  }
`;
